module.exports = __webpack_public_path__ + "static/bg-construction-91c95ccb206066e7b413a524a9691d79.jpg";